import { render, staticRenderFns } from "./sejarah.vue?vue&type=template&id=f825d5c2&"
import script from "./sejarah.vue?vue&type=script&lang=js&"
export * from "./sejarah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports